import { useRoute } from 'config/routes';
import { ShareType, shareHandler } from 'helpers/share-helpers';
import { useLocale } from 'locale';
import { useContext } from 'react';
import { routeContext } from 'react-router5';
import { isServer } from 'utils';
import { createWhatsAppLink } from 'utils/shareLinksUtils';

export const useShareHandler = (officeName: string) => {
  const { route: { params: { id }, name } } = useRoute();
  const router = useContext(routeContext);
  const { t } = useLocale();

  const url = isServer() ? null : window.location.origin + router.router.buildUrl(name, { id });

  return (shareType: ShareType) => {
    if (shareType === ShareType.Email) {
      const subjectText = t('mortgage.officePage.shareButton.emailSubject', { officeName });
      const bodyText = url;
      const uri = `mailto:?subject=${subjectText}&body=${bodyText}`;
      window.location.href = encodeURI(uri);
    }
    else if (shareType === ShareType.WhatsApp) {
      const urlObj = new URL(url);
      urlObj.search = '';

      const href = createWhatsAppLink({ text: `${t('mortgage.officePage.shareButton.emailSubject', { officeName })}, ${urlObj.toString()}` });

      window.open(href);
    }
    else {
      shareHandler({ type: shareType, url, shareViaEmailOptions: { t } });
    }
  };
};
